import { Record } from 'immutable';

export const defaultApiValues = {
  profile: null,
  languageCode: 'en',
  title: null,
  regionCode: null,
  postalCode: null,
  administrativeArea: null,
  locality: null,
  streetAddress: null,
  primaryCategoryId: null,
  primaryPhone: null,
  latitude: null,
  longitude: null,
  locationId: null,
};

// object dto with api
export default class GbpLocation extends Record(defaultApiValues, GbpLocation) {
  constructor(values) {
    super({
      ...values,
    });
  }

  /**
   * generate request body format for the create location endpoint
   * @param {GbpLocation} location location record
   * @returns gbp location create object
   */
  static generateGbpCreateEntity(location) {
    const result = {
      profile: {
        description: location.get('profile')
      },
      language_code: location.get('languageCode'),
      title: location.get('title'),
      storefrontAddress: {
        languageCode: location.get('languageCode'),
        regionCode: location.get('regionCode'),
        locality: location.get('locality'),
        addressLines: [location.get('streetAddress')],
        administrativeArea: location.get('administrativeArea'),
        postalCode: location.get('postalCode'),
      },
      categories: {
        primaryCategory: {
          name: location.get('primaryCategoryId'),
        }
      },
      phoneNumbers: {
        primaryPhone: location.get('primaryPhone'),
      },
      googleLocationId: location.get('locationId') ? location.get('locationId').split('/')[1] : null
    };

    const latitude = location.get('latitude'), longitude = location.get('longitude');

    if (latitude && longitude) {
      result['latlng'] = {
        latitude,
        longitude,
      }
    }

    return result;
  }

  /**
   * generate request body format for the update location endpoint
   * @param {GbpLocation} location location record
   * @returns gbp location update object
   */
  static generateGbpUpdateEntity(location) {
    return {
      phoneNumbers: {
        primaryPhone: location.get('primaryPhone'),
      },
      name: location.get('locationId'),
    };
  }

  static generateGbpIntiateVerificationEntity(verificationOptionObj) {
    return {
      languageCode : "EN",
      method : verificationOptionObj.get('verificationMethod'),
      phoneNumber: verificationOptionObj.get('phoneNumber'),
      emailAddress: verificationOptionObj.get('emailAddress')
    };
  }

  static generateVerificationSubmitEntity(pin, verificationProcess, location) {
    return { 
      pin: pin,
      title: location.get("title"),
      storefrontAddress: {
        languageCode: location.get('languageCode'),
        regionCode: location.get('regionCode'),
        locality: location.get('locality'),
        addressLines: [location.get('streetAddress')],
        administrativeArea: location.get('administrativeArea'),
        postalCode: location.get('postalCode'),
      },
      googleLocationId: verificationProcess.get("locationId"),
      verificationId: verificationProcess.get("verificationId"),
      phoneNumbers: location.get('primaryPhone'),
    };
  }
}
